<div class="app-header">
  <div nz-row nzJustify="space-between" nzAlign="middle" class="app-header__row">
    <div nz-col>
      <span class="header-trigger" (click)="collapse$.emit(!isCollapsed)">
        <i class="trigger" nz-icon [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"></i>
      </span>
    </div>
    <div nz-col class="app-header__actions">
      <button
        nz-button
        nzType="text"
        class="theme-toggle"
        type="button"
        nz-tooltip
        [nzTooltipTitle]="themeService.isDark() ? 'Светлая тема' : 'Тёмная тема'"
        (click)="themeService.toggleTheme($event)"
      >
        <span nz-icon [nzType]="themeService.isDark() ? 'sun' : 'moon'" nzTheme="outline"></span>
      </button>
      <button
        nz-button
        nzType="text"
        class="theme-toggle"
        type="button"
        nz-popover
        nzPopoverTitle="Цветовая схема"
        [nzPopoverContent]="colorSchemePicker"
        nzPopoverOverlayClassName="color-scheme-popover"
        nzPopoverPlacement="bottomRight"
        nzPopoverTrigger="click"
        nz-tooltip
        nzTooltipTitle="Цветовая схема"
      >
        <span class="color-swatch" [style.background]="themeService.colorScheme().swatch"></span>
      </button>
      <ng-template #colorSchemePicker>
        <div class="color-scheme-picker">
          <button
            *ngFor="let scheme of themeService.colorSchemes"
            class="color-scheme-option"
            type="button"
            [class.color-scheme-option--active]="scheme.id === themeService.colorScheme().id"
            (click)="themeService.setColorScheme(scheme)"
          >
            <span class="color-scheme-option__swatch" [style.background]="scheme.swatch"></span>
            <span class="color-scheme-option__label">{{ scheme.label }}</span>
            <span *ngIf="scheme.id === themeService.colorScheme().id" nz-icon nzType="check" class="color-scheme-option__check"></span>
          </button>
        </div>
      </ng-template>
      <app-session-dropdown></app-session-dropdown>
    </div>
  </div>
</div>
